import React from "react";
import LegalPageLayout from "@user/components/LegalPageLayout";
import { SUPPORT_EMAIL } from "@/config/support";
import { Mail, Phone, MapPin } from "lucide-react";

/**
 * Contact Us — required by Cashfree, and by RBI's payment-aggregator KYC
 * checklist. Displays merchant identity, contact email/phone, and postal
 * address. Kept plain because Cashfree operators read this before approving.
 */
export default function ContactUs() {
  return (
    <LegalPageLayout title="Contact Us" lastUpdated="7 February 2026">
      <p>
        We&apos;d love to hear from you. Whether you&apos;re a client seeking legal
        help, a lawyer interested in joining our network, or a partner exploring
        collaboration, our team is here to help.
      </p>

      <h2>Reach Us</h2>
      <ul className="not-prose space-y-4 mt-4" data-testid="contact-methods">
        <li className="flex items-start gap-3">
          <Mail className="text-[#0A2540] mt-1 flex-shrink-0" size={18} />
          <div>
            <p className="font-semibold text-[#0A2540]">Email</p>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="text-slate-700 hover:text-[#0A2540] underline"
              data-testid="contact-email"
            >
              {SUPPORT_EMAIL}
            </a>
            <p className="text-xs text-slate-500 mt-1">
              For payments, refunds, and account issues, please write from your
              registered email so we can verify your identity quickly.
            </p>
          </div>
        </li>
        <li className="flex items-start gap-3">
          <Phone className="text-[#0A2540] mt-1 flex-shrink-0" size={18} />
          <div>
            <p className="font-semibold text-[#0A2540]">Phone</p>
            <a
              href="tel:+919876543210"
              className="text-slate-700 hover:text-[#0A2540] underline"
              data-testid="contact-phone"
            >
              +91 98765 43210
            </a>
            <p className="text-xs text-slate-500 mt-1">
              Available Monday to Saturday, 10:00 AM to 7:00 PM IST.
            </p>
          </div>
        </li>
        <li className="flex items-start gap-3">
          <MapPin className="text-[#0A2540] mt-1 flex-shrink-0" size={18} />
          <div>
            <p className="font-semibold text-[#0A2540]">Registered Address</p>
            <address
              className="text-slate-700 not-italic"
              data-testid="contact-address"
            >
              Advoset Technologies Private Limited<br />
              1st Floor, Prestige Meridian, M.G. Road<br />
              Bengaluru, Karnataka 560001<br />
              India
            </address>
          </div>
        </li>
      </ul>

      <h2>Response Time</h2>
      <p>
        We aim to acknowledge every email within one working day. Payment- or
        refund-related tickets are escalated the same day.
      </p>

      <h2>Grievance Officer</h2>
      <p>
        In line with the Consumer Protection (E-Commerce) Rules, 2020, our
        grievance officer can be reached at{" "}
        <a href="mailto:grievance@advoset.in">grievance@advoset.in</a>. We
        respond to grievances within 48 hours and resolve them within 15 days
        of receipt.
      </p>
    </LegalPageLayout>
  );
}
